(function () {
  if (window.__productHoverVideoInit) return;
  window.__productHoverVideoInit = true;
  function init() {
    if (!window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('.product__hover-video').forEach(function (v) {
      if (v.dataset.hoverBound) return;
      v.dataset.hoverBound = '1';
      var c = v.closest('.product-media-container');
      if (!c) return;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      c.addEventListener('mouseenter', function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); });
      c.addEventListener('mouseleave', function () { v.classList.remove('is-playing'); v.pause(); });
      c.addEventListener('click', function () { v.classList.remove('is-playing'); v.pause(); v.style.display = 'none'; });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
